import { render, staticRenderFns } from "./SealDialog.vue?vue&type=template&id=b2f1e690&"
import script from "./SealDialog.vue?vue&type=script&lang=js&"
export * from "./SealDialog.vue?vue&type=script&lang=js&"
import style0 from "./SealDialog.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports